<template>
  <div>
    <cancel-heading
      subheading="Your Feedback is Important to Us"
    >Why are you canceling?</cancel-heading>

    <div class="mt-100">
      <p
        v-for="(option, index) in shuffledOptions"
        :class="['reason_option', {'chosen': currentReason === option.reason}]"
        @click="setReason(option.reason)"
      >
        <span class="reason_option--count">{{ index + 1 }}</span> {{ option.label }}
      </p>

      <form-field-textarea
        v-if="showComment"
        :label="commentLabel"
        class="reason_option--comment"
        v-model="comment"
        @input="updateComment"
        placeholder="We read every answer"
        rows="3"
      />
    </div>
  </div>
</template>

<script>
import CancelHeading from "./components/CancelHeading.vue";
import CancelContent from "./components/CancelContent.vue";
import {ENUMS} from "../../../services/enums";

export default {
  name: "ReasonWhy",
  components: {CancelContent, CancelHeading},
  props: {
    value: {},
  },
  data() {
    return {
      options: [
        {
          label: 'Switching to another CRM',
          reason: ENUMS.CancelAttemptReasonEnum.Switching.value
        },
        {
          label: 'Too Difficult to Use',
          reason: ENUMS.CancelAttemptReasonEnum.TooDifficult.value
        },
        {
          label: 'Doesn\'t Fit My Budget',
          reason: ENUMS.CancelAttemptReasonEnum.TooExpensive.value
        },
        {
          label: 'Not Satisfied with the Product',
          reason: ENUMS.CancelAttemptReasonEnum.NotSatisfied.value
        },
        {
          label: 'Other Reason',
          reason: ENUMS.CancelAttemptReasonEnum.Other.value
        },
      ],
      comment: null,
      currentReason: null,
    }
  },
  computed: {
    shuffledOptions() {
      const array = this.options
      let currentIndex = array.length, randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex != 0) {

        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
          array[randomIndex], array[currentIndex]];
      }

      return array;
    },
    showComment() {
      const commentReasons = [
        ENUMS.CancelAttemptReasonEnum.Switching.value,
        ENUMS.CancelAttemptReasonEnum.Other.value
      ]

      return commentReasons.includes(this.currentReason)
    },
    commentLabel() {
      if (this.currentReason === ENUMS.CancelAttemptReasonEnum.Switching.value) {
        return 'Which solution will you be moving to?'
      }

      if (this.currentReason === ENUMS.CancelAttemptReasonEnum.Other.value) {
        return 'What could we have done better?'
      }

      return ''
    }
  },
  methods: {
    updateComment(content) {
      this.$emit('input', this.comment)
    },
    setReason(reason) {
      this.comment = null
      this.$emit('input', null)

      this.currentReason = reason
      this.$emit('reason', reason)
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.reason_option {
  position: relative;
  margin-top: 10px;
  padding-left: 1.5rem;
  font-size: 1.125rem;
  cursor: pointer;

  &:hover {
    color: $primary;
  }

  &.chosen {
    color: $primary;

    &:before {
      content: '\2713';
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      color: $primary;
    }

    .reason_option--count {
      border-color: $primary;
      color: $primary;
    }
  }

  &--count {
    display: inline-block;
    width: 26px;
    height: 26px;
    border: 1px solid $borderDark;
    border-radius: 5px;
    color: $text-light;
    text-align: center;
    line-height: 26px;
  }

  &--comment {
    margin-top: 18px;
    padding-left: 1rem;
  }
}
</style>
